import axios from 'axios';
import { ResponsiveEmbed } from 'react-bootstrap';
import { call, put, select } from 'redux-saga/effects';
import { API } from '../constants/api';
import { methods } from '../constants/constants';
import { actions } from '../reducers/materias';
import { actions as academiesActions } from '../reducers/academies';
import { sagaNames, handleSagaError } from './index';
import { academiesFromStore } from './academies';

// Gets materiasAlreadyFetched
export const materiasFromStore = state => state.materias.materias;
export const materiasDisponiblesFromStore = state => state.materias.materiasDisponibles;

function fetchMaterias() {
	return axios({
        method: methods.GET,
        url: API.MATERIAS.GET_LIST_MATERIAS_ACADEMIAS,
	});
}

function postMateriasData(materia) {
	return axios({
		method: methods.POST,
		url: API.MATERIAS.GET_LIST_MATERIAS,
    data: {
        nombre: materia.nombre,
        id_academia: materia.id_academia,
    },
	});
}

function putMateriasData(materia) {
	return axios({
        method: methods.PUT,
        url: API.MATERIAS.GET_LIST_MATERIAS,
    data: {
        id: materia.id,
        nombre: materia.nombre,
        id_academia: materia.id_academia,
    },
	});
}

function deleteMateriasData(materia) {
	return axios({
		method: methods.DELETE,
        url: API.MATERIAS.GET_LIST_MATERIAS,
        data: {
            id: materia.id,
            nombre: materia.nombre,
            id_academia: materia.id_academia,
        }
	});
}

function fetchMateriasDisponibles() {
	return axios({
        method: methods.GET,
        url: API.MATERIAS.GET_LIST_MATERIAS_DISPONIBLES,
	});
}

export function* getMaterias() {
  try {
    const materiasStore = yield select(materiasFromStore);
    let materias = null;
    if (!materiasStore || (Array.isArray(materiasStore) && materiasStore.length === 0)) {
      const response = yield call(fetchMaterias);
      materias = response && response.data;
    } else {
      materias = materiasStore;
    }
      yield put(actions.successGetMaterias(materias));

  } catch (error) {
    const reducerFailureAction = actions.errorGetMaterias(error);
    yield handleSagaError(sagaNames.GET_MATERIAS, error, reducerFailureAction);
  }
}

export function* postMaterias(args) {
    try {
        //debugger;
    const response = yield call(postMateriasData, args.materia);
    // const status = response && response.status;
    yield put(actions.successPostMaterias(response));
  } catch (error) {
    const reducerFailureAction = actions.errorPostMaterias(error);
    yield handleSagaError(sagaNames.POST_MATERIAS, error, reducerFailureAction);
  }
}

export function* editMaterias(args) {
  try {
    const response = yield call(putMateriasData, args.materia);
    // const status = response && response.status;
    yield put(actions.successEditMaterias(response));
  } catch (error) {
    const reducerFailureAction = actions.errorEditMaterias(error);
    yield handleSagaError(sagaNames.EDIT_MATERIAS, error, reducerFailureAction);
  }
}

export function* deleteMaterias(args) {
    try {
        //debugger;
    const response = yield call(deleteMateriasData, args.materia);
    // const status = response && response.status;
        yield put(actions.successDeleteMaterias(response));
  } catch (error) {
    const reducerFailureAction = actions.errorDeleteMaterias(error);
    yield handleSagaError(sagaNames.DELETE_MATERIAS, error, reducerFailureAction);
  }
}

export function* getMateriasDisponibles() {
  try {
    const materiasDisponiblesStore = yield select(materiasDisponiblesFromStore);
    let materiasDisponibles = null;
    if (!materiasDisponiblesStore || (Array.isArray(materiasDisponiblesStore) && materiasDisponiblesStore.length === 0)) {
      const response = yield call(fetchMateriasDisponibles);
      materiasDisponibles = response && response.data;
    } else {
      materiasDisponibles = materiasDisponiblesStore;
    }
      yield put(actions.successGetMateriasDisponibles(materiasDisponibles));

  } catch (error) {
    const reducerFailureAction = actions.errorGetMateriasDisponibles(error);
    yield handleSagaError(sagaNames.GET_MATERIAS_DISPONIBLES, error, reducerFailureAction);
  }
}